import React from "react";
import "./galeria.css";


import img1 from "../../assets/img/galeria/img1.png";
import img2 from "../../assets/img/galeria/img2.png";
import img3 from "../../assets/img/galeria/img3.png";
import img4 from "../../assets/img/galeria/img4.png";
import img5 from "../../assets/img/galeria/img5.png";
import img6 from "../../assets/img/galeria/img6.png";
import img7 from "../../assets/img/galeria/img7.png";



import Gallery from "../../components/gallery/gallery";
import VideoPlayer from "../../components/videoPlayer/videoPlayer";
import History from "../history/history";

interface Image {
    src: string;
    alt: string;
}

const imageList: Image[] = [
    { src: img1, alt: "Image 1" },
    { src: img2, alt: "Image 2" },
    { src: img3, alt: "Image 3" },
    { src: img4, alt: "Image 3" },
    { src: img5, alt: "Image 3" },
    { src: img6, alt: "Image 3" },
    { src: img7, alt: "Image 3" },
];

interface HistoryProps {
    innerRef: React.RefObject<HTMLDivElement>;
  }



const Galeria: React.FC <HistoryProps> = ({innerRef}) => {
    return (

        <div className="galeria">
            
            <div className="midia-header">
                <VideoPlayer />

            </div>

            <div className="midia-end">
                <Gallery images={imageList} />
                
            </div>

            <div ref={innerRef} style={{marginTop: '30%'}}>
            <History />
            </div>

        </div>

    );
};

export default Galeria;
